import { EnvConfig } from '@config';
import { ApiResponse } from 'types/apiResponse';
import { UserDTO } from 'types/wellGuardian';

import Client from './client';

const userAccessApiBaseUrl = EnvConfig.drillx_wg_api_url || '';
const accept = 'application/json';

// TODO: Once the merge of the microservices is finished, rename / merge this
class UserApiClient {
  client: Client;

  constructor() {
    this.client = new Client(userAccessApiBaseUrl, accept);
  }

  getUser = async (): Promise<ApiResponse<UserDTO | null>> => {
    const user = await this.client.get('/users/me');
    // TODO: catch 401 and redirect to login page

    return { response: user };
  };

  getUsers = async (): Promise<UserDTO[]> => {
    try {
      const users = await this.client.get('/users/all');

      return users;
    } catch {
      return [];
    }
  };
}

export default new UserApiClient();
